import React from 'react';
import { useTranslation } from 'react-i18next';

import { AnimatedBubbles } from '@bonusly/common-page-loading';
import { Heading, rem, VStack } from '@bonusly/design-system';

const LoadingContent: React.FC = () => {
	const { t } = useTranslation('feedback');

	return (
		<VStack p={32} position="relative">
			<AnimatedBubbles maxW={rem(300)} />
			<Heading
				as="h1"
				size="xl"
				color="text.softest"
				position="relative"
				top={{ base: 0, sm: '-50px' }} // Reduce gap between animation and label for large screens
			>
				{t('feedback.template.loading')}
			</Heading>
		</VStack>
	);
};

export default LoadingContent;
